export default __webpack_public_path__ + "static/media/action.5fb05283.png";